import { render, staticRenderFns } from "./SelfAssessmentLaborConditions.vue?vue&type=template&id=642d1b90&"
import script from "./SelfAssessmentLaborConditions.vue?vue&type=script&lang=js&"
export * from "./SelfAssessmentLaborConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports